define('current-user-answer',['require','jquery','config','helpers'],function(require) {
    'use strict';

    var $ = require('jquery'),
        config = require('config'),
        helpers = require('helpers');

    return function(answers, id) {

        var answer  = (function() {
            var i       = 0,
                len     = answers.length,
                match   = false;

            while (i < len) {
                if ( answers[i].contentEntityId === id ) {
                    match = true;
                    break;
                }
                i++;
            }

            return (match) ? answers[i] : null;
        })();

        function add(val) {
            if ( answer && answer.answers && answer.answers ) {
                answer.answers.push(val);
            }
        }

        function update(obj) {
            if ( answer ) {
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        answer[prop] = obj[prop];
                    }
                }
            }
        }

        function getAnswers() {
            return answer.answers;
        }

        function isAnswered() {
            var value = ( answer && (answer.answered || answer.answers && answer.answers.length) ) ? true : false;
            return value;
        }

        function isVisited() {
            return ( answer && answer.visited ) ? true : false;
        }

        function isNotKnowOptionChecked(id) {
            var i           = 0,
                answerExist = false,
                userAnswers = answer.answers,
                len         = userAnswers.length,
                match       = false;

            while (i < len) {
                if ( userAnswers[i].questionId === id ) {
                    if ( !userAnswers[i].answerId ) {
                        match = true;
                        break;
                    }
                    answerExist = true;
                }
                i++;
            }

            return (match || !answerExist) ? id : '';
        }

        function getAnswerIdByQuestionId(questionId) {
            var i           = 0,
                userAnswers = answer.answers,
                len         = userAnswers.length,
                match       = false;

            while (i < len) {
                if ( userAnswers[i].questionId === questionId ) {
                    match = true;
                    break;
                }
                i++;
            }

            return (match) ? userAnswers[i].answerId : '';
        }

        function getAnswersIdByQuestionId(questionId) {
            var i           = 0,
                arr         = [],
                userAnswers = answer.answers,
                len         = userAnswers.length;

            while (i < len) {
                if ( userAnswers[i].questionId === questionId ) {
                    arr.push( userAnswers[i].answerId );
                }
                i++;
            }

            return arr.reverse();
        }

        function getAnswerTextByAnswerId(answerId) {
            var i           = 0,
                userAnswers = answer.answers,
                len         = userAnswers.length,
                match       = false;

            while (i < len) {
                if ( userAnswers[i].answerId === answerId ) {
                    match = true;
                    break;
                }
                i++;
            }

            return (match) ? userAnswers[i].answerText : '';
        }

        function isAnswerValueEqual(answerId) {
            var i           = 0,
                userAnswers = answer.answers,
                len         = userAnswers.length,
                match       = false;

            while (i < len) {
                if ( userAnswers[i].answerId === answerId ) {
                    match = true;
                    break;
                }
                i++;
            }

            return (match) ? true : false;
        }

        function getAnswerTextByQuestionId(questionId) {
            var i           = 0,
                userAnswers = answer.answers,
                len         = userAnswers.length,
                match       = false;

            while (i < len) {
                if ( userAnswers[i].questionId === questionId ) {
                    match = true;
                    break;
                }
                i++;
            }

            return (match) ? userAnswers[i].answerText : '';
        }

        function getQuestionIdByAnswerId(answerId) {
            var i           = 0,
                userAnswers = answer.answers,
                len         = userAnswers.length,
                match       = false;

            while (i < len) {
                if ( userAnswers[i].answerId === answerId ) {
                    match = true;
                    break;
                }
                i++;
            }

            return (match) ? userAnswers[i].questionId : '';
        }

        function updateTrainingData(action, data, previewMode) {
            var trainingId = helpers.URL.getParam('id'),
                tokenId = helpers.URL.getParam('tokenId'),
                userID = '',
                isPreviewMode = previewMode || helpers.URL.getParam('previewMode').toLowerCase() === 'true',
                headerSettings = {'Authorization-Token': tokenId},
                setLocalLastVisited = function(id) {
                    if (id) {
                        data.user.lastVisitedContentEntityId = id;
                    }
                },
                updateLocalData = function() {
                    var getUserID = function( data ) {
                        if ( !data || typeof data !== 'object' ) {
                            return;
                        }
                        if ( !data.hasOwnProperty('user') || !data.user || typeof data.user !== 'object' ) {
                            return;
                        }
                        if ( !data.user.hasOwnProperty('id') || !data.user.id ) {
                            return;
                        }
                        return data.user.id;
                    },
                    getTrainingID  = function( data ) {
                        if ( !data || typeof data !== 'object' ) {
                            return;
                        }
                        if ( !data.hasOwnProperty('training') || !data.training || typeof data.training !== 'object' ) {
                            return;
                        }
                        if ( !data.training.hasOwnProperty('id') || !data.training.id ) {
                            return;
                        }
                        return data.training.id;
                    };

                    if ( isPreviewMode ) {
                        return;
                    }

                    if ( config.offlinePackage ) {
                        trainingId = getTrainingID( data );
                    }

                    if ( window.localStorage && config.localStorage ) {

                        userID = getUserID( data );

                        if ( userID ) {
                            localStorage.setItem( trainingId + '-' + userID, JSON.stringify( data.user ) );
                        }

                    }
                },
                updateServerData = function( lessonId, answers, contentEntityId ) {
                    var i           = 0,
                        len         = (answers) ? answers.length : 0,
                        answer      = null,
                        postData    = {
                            trainingId  : trainingId,
                            lessonId    : lessonId,
                            answers     : []
                        };

                    if ( isPreviewMode || !window.navigator.onLine ) {
                        return;
                    }

                    while (i < len) {
                        answer = answers[i];

                        if (answer.questionId) {
                            postData.answers.push({
                                questionId  : answer.questionId,
                                answerId    : answer.answerId,
                                text        : answer.answerText
                            });
                        }

                        i++;
                    }

                    $.ajax({
                        type        : 'POST',
                        url         : config.logURL,
                        headers     : headerSettings,
                        data        : JSON.stringify(postData),
                        contentType : 'application/json; charset=utf-8',
                        dataType    : 'json',
                        success     : function() {
                            switch (action) {
                            case 'synchronize':
                                var i = 0,
                                    answers = ( data && data.hasOwnProperty('user') && data.user && typeof data.user === 'object' && data.user.hasOwnProperty('answers') && data.user.answers ) ? data.user.answers : null;

                                if ( answers && answers.length ) {
                                    i = answers.length;
                                    while(i--) {
                                        if ( answers[i].contentEntityId === contentEntityId ) {
                                            answers[i].submitted = true;
                                            break;
                                        }
                                    }
                                }

                                break;
                            default:
                                update({'submitted': true});
                            }

                            updateLocalData();

                        },
                        error       : function() {
                            // if 401 redirect to login
                        }
                    });

                };

            switch(action) {
                case 'visited':

                    update({visited: true});

                    setLocalLastVisited(id);

                    updateLocalData();

                    if ( !config.offlinePackage ) {
                        updateServerData( id, null, '' );
                    }
                    break;
                case 'update':

                    updateLocalData();

                    if ( !config.offlinePackage ) {
                        updateServerData( id, getAnswers(), '' );
                    }
                    break;
                case 'synchronize':

                    if ( !config.offlinePackage ) {
                        answers.forEach(function(el) {
                            // if (!el.submitted && el.visited) {
                            if (el.visited) {
                                if ( el.answers && el.answers.length ) {
                                    updateServerData( el.contentEntityId, el.answers, el.contentEntityId );
                                } else {
                                    updateServerData( el.contentEntityId, null, el.contentEntityId );
                                }
                            }
                        });
                    }

                    break;
            }

        }

        return {
            add                     : add,
            update                  : update,
            answer                  : answer,
            answers                 : getAnswers,
            answered                : isAnswered,
            visited                 : isVisited,
            updateTrainingData          : updateTrainingData,
            isAnswerValueEqual          : isAnswerValueEqual,
            isNotKnowOptionChecked      : isNotKnowOptionChecked,
            getAnswerIdByQuestionId     : getAnswerIdByQuestionId,
            getAnswersIdByQuestionId    : getAnswersIdByQuestionId,
            getAnswerTextByAnswerId     : getAnswerTextByAnswerId,
            getAnswerTextByQuestionId   : getAnswerTextByQuestionId,
            getQuestionIdByAnswerId     : getQuestionIdByAnswerId
        };
    };

});

